import Loading from '@/components/loading/loading';
import { Flex, InlineAlert, Text } from '@cmpsr/components';
import ModalRemoveActiveInterventions from '../modals/remove-active-interventions/remove-active-interventions-modal';
import useBuildActionPlanController from './build-action-plan.controller';
import Footer from './components/footer/footer';
import Header from './components/header/header';
import InterventionTabs from './components/interventions/tabs';
import ModalIntroWizard from '../modal-intro-wizard/modal-intro-wizard';

export default function BuildActionPlan() {
  const {
    handleFinishIntroWizard,
    handleItemSelectionChange,
    handleRemoveActiveInterventions,
    handleSaveActionPlan,
    interventions,
    interventionsToRemove,
    isLoading,
    isMaxSelectionReached,
    isRemoveActiveInterventionsOpen,
    modalIntroWizardDisclosure,
    onCloseRemoveActiveInterventions,
    selectedItems,
    showError,
  } = useBuildActionPlanController();

  if (isLoading) return <Loading />;

  return (
    <>
      <Header />
      <Flex as="main" justifyContent="center" alignItems="center" w="full">
        <Flex
          direction="column"
          justifyContent="center"
          alignItems="center"
          pt="spacer-12"
          w={{ base: 'full', md: '672px' }}
          px="spacer-5"
        >
          <Text variant="text-header-2XL">Action Plan Builder</Text>
          <Text variant="text-body-regular" color="text-secondary" py="spacer-3">
            Pick up to 5 actions {`(${selectedItems.length} selected)`}
          </Text>
          {showError && (
            <InlineAlert
              status="error"
              backgroundColor="background-error"
              borderRadius="radii-2"
              w="full"
              alignItems="start"
              py="spacer-3"
              px="spacer-5"
            >
              <InlineAlert.Icon />
              <InlineAlert.Message>Please select at least one item for your action plan</InlineAlert.Message>
            </InlineAlert>
          )}
          <InterventionTabs
            interventions={interventions}
            selectedItems={selectedItems}
            onItemSelectionChange={handleItemSelectionChange}
            isMaxSelectionReached={isMaxSelectionReached}
            isLoading={isLoading}
          />
        </Flex>
        <Footer onSaveActionPlan={handleSaveActionPlan} />
        <ModalRemoveActiveInterventions
          interventions={interventionsToRemove}
          isOpen={isRemoveActiveInterventionsOpen}
          onClose={onCloseRemoveActiveInterventions}
          onRemove={handleRemoveActiveInterventions}
        />
        <ModalIntroWizard
          isOpen={modalIntroWizardDisclosure.isOpen}
          onClose={modalIntroWizardDisclosure.onClose}
          onFinish={handleFinishIntroWizard}
        />
      </Flex>
    </>
  );
}
